export const formatLocationDimensions = dimensionsArray => {
  if (!dimensionsArray || dimensionsArray.length === 0) return "N/A";
  const { width, depth, height } = dimensionsArray[0];
  return `${width} x ${depth} x ${height}`;
};

export const formatAssetDimensions = dimensions => {
  if (!dimensions.length) return "N/A";
  return dimensions.map(({ width, depth, height }) => [width, depth, height].join("x")).join(", ");
};
